<template>
  <el-container v-loading="isShowLoading">
    <el-aside style="border-right: 1px solid #eeeeee;" v-show="treeVisible">
      <el-container>
        <el-header style="padding-top: 20px;">
          <el-input
            placeholder="开票单位编码或名称"
            v-model="filterText"
            style="margin-top:'21px';height:'31px';"
            clearable
          ></el-input>
        </el-header>
        <el-main>
          <el-tree
            :data="agency"
            ref="agencyTree"
            :expand-on-click-node="false"
            class="filter-tree"
            v-loading="treeLoading"
            :filter-node-method="filterNode"
            @check="checkNode"
            :check-strictly="true"
            :highlight-current="true"
            node-key="id"
            :props="this.defaultProps"
            accordion
            @node-click="handleTreeClick"
            :default-expanded-keys="defaultOpen"
          ></el-tree>
        </el-main>
      </el-container>
    </el-aside>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-form :model="filterData" :inline="true">
            <el-form-item>
              <el-input v-model="filterData.placeName" placeholder="开票点名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="filterData.placeCode" placeholder="开票点编码" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="filterData.level" placeholder="开票点级次" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table
        ref="singleTable"
        :data="recordData"
        highlight-current-row
        style="width: 100%; overflow: auto;"
        :row-style="{height:'30px'}"
        height="250px"
        @row-click="getCurrentAgencyPlaceRow"
        :header-cell-style="{background:'#f5f7fa', color: 'black'}"
        border
        :stripe="stripeVisible"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column property="agencyName" label="单位名称" width="240" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="agencyCode" label="单位编码" width="180" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="placeName" label="开票点名称" width="180" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="placeCode" label="开票点编码" width="100"></el-table-column>
        <el-table-column property="level" label="开票点级次" width="100"></el-table-column>
        <el-table-column property="updateTime" label="更新时间" width="160"></el-table-column>
        <el-table-column property="updateMode" label="更新方式" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.updateMode == '1'">
              <i class="el-icon-success"></i>手动
            </div>
            <div v-else-if="scope.row.updateMode == '0'">
              <i class="el-icon-remove"></i>自动
            </div>
          </template>
        </el-table-column>
        <el-table-column property="updateUserName" label="更新人" width="100"></el-table-column>
      </el-table>
      <el-row>
        <el-col :span="24">
          <pagination
            v-show="pagination.total/pagination.pageSize>1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageSize"
            @pagination="onFilter"
          />
        </el-col>
      </el-row>
      <div style="height: 10px" v-show="pagination.total/pagination.pageSize<2"></div>
      <el-row>
        <el-col :span="24">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="onAdd"
            v-bind:disabled="enableBtn.xz"
          >新增</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-delete"
            @click="onDel"
            v-bind:disabled="enableBtn.sc"
          >删除</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-download"
            @click="onDown"
            v-bind:disabled="enableBtn.tb"
          >同步</el-button>
        </el-col>
      </el-row>

      <el-table
        ref="singleTable"
        :data="recordTypeData"
        highlight-current-row
        style="width: 100%"
        height="250px"
        :row-style="{height:'30px'}"
        @row-dblclick="onRowDblclick"
        :header-cell-style="{background:'#f5f7fa', color: 'black'}"
        border
        :stripe="stripeVisible"
      >
        <el-table-column property="agencyCode" label="选择" align="center" width="100">
          <template slot-scope="scope">
            <el-radio
              :label="scope.$index+1"
              v-model="itemRadio"
              @change.native="getCurrentAgencyPlaceEinvoiceTypeRow(scope.row)"
            ></el-radio>
          </template>
        </el-table-column>
        <el-table-column property="placeName" label="开票点名称" width="180" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="placeCode" label="开票点编码" width="100" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="itemName" label="收费项目名称" width="140" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="itemCode" label="收费项目编码" width="110" show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="sum" label="明细总数" width="100"></el-table-column>
        <el-table-column property="updateTime" label="更新时间" width="155"></el-table-column>
        <el-table-column property="updateMode" label="更新方式" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.updateMode == '1'">
              <i class="el-icon-success"></i>手动
            </div>
            <div v-else-if="scope.row.updateMode == '0'">
              <i class="el-icon-remove"></i>自动
            </div>
          </template>
        </el-table-column>
        <el-table-column property="updateUserName" label="更新人" width="100"></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button size="mini" @click="onDealItemAux(scope.row)" type="primary">明细管理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col :span="24" style="margin: 8px 0px">
          <pagination
            v-show="typePagination.total/typePagination.pageSize>1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="typePagination.total"
            :page.sync="typePagination.page"
            :limit.sync="typePagination.pageSize"
          />
        </el-col>
      </el-row>

      <div style="height: 60px"></div>
      <el-drawer
        :visible.sync="layout.edit"
        :show-close="false"
        :wrapperClosable="false"
        :withHeader="false"
        :size="pageWidth + 'px'"
        direction="rtl"
        custom-class="demo-drawer"
        style="top: 67px"
      >
        <div class="demo-drawer-content">
          <Entity
            v-if="layout.edit"
            @back="back"
            v-bind:entity="entityData"
            ref="itemPanel"
          ></Entity>
        </div>
      </el-drawer>

      <el-drawer
        :visible.sync="layout.dealItemAux"
        :show-close="false"
        :wrapperClosable="false"
        :withHeader="false"
        :size="pageWidth + 'px'"
        direction="rtl"
        custom-class="demo-drawer"
        style="top: 67px"
      >
        <div class="demo-drawer-content">
          <ItemAuxView
            v-if="layout.dealItemAux"
            @back="dealItemAuxBack"
            v-bind:itemAuxEntityData="itemAuxEntityData"
            ref="itemPanel"
          ></ItemAuxView>
        </div>
      </el-drawer>
    </el-main>
  </el-container>
</template>

<script>
import Entity from "./Entity.vue";
import ItemAuxView from "./ItemAuxView.vue";

let _kits, _table, _itemTable;
export default {
  components: {
    Entity,
    ItemAuxView
  },
  data() {
    return {
      view: {
        showOrgan: false,
        showArea: false
      },
      radio: "",
      itemRadio: "", //开票点票种选中状态
      templateSelection: {},
      typeTemplateSelection: {},
      agency: [],
      filterText: "",
      defaultOpen: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      isShowLoading: true,
      pageWidth: 600,
      //页面布局相关
      layout: {
        loading: true,
        width: 600,
        wd: "80%",
        edit: false,
        dealItemAux: false
      },
      //数据绑定相关
      filterData: {
        agencyCode: "",
        placeCode: "",
        placeName: "",
        level: ""
      }, //过滤信息
      recordData: [], //展示开票点信息
      filterTypeData: {
        agencyCode: "",
        placeCode: ""
      },
      recordTypeData: [], //展示开票点票种
      pagination: {
        total: 0,
        page: 1,
        pageSize: 100
      }, //分页信息
      typePagination: {
        total: 0,
        page: 1,
        pageSize: 200
      },
      entityData: {}, //具体某一项信息
      itemAuxEntityData: {
        agencyCode: "",
        placeCode: "",
        itemCode: ""
      },
      enableBtn: {
        //控制启用禁用
        sc: true,
        tb: true,
        xz: true,
        xg: true
      },
      agencyNum: 0, //树结构中的开票单位数量
      agencyXx: []
    };
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1 || data.id.indexOf(value) !== -1;
    },
    checkNode(node, nodes) {
      let checkKeys = this.$refs["agencyTree"].getCheckedKeys();
      if (checkKeys.length > 1) {
        this.$refs["agencyTree"].setCheckedKeys([node.id]);
        return;
      }
    },
    getCurrentAgencyPlaceEinvoiceTypeRow(row) {
      //获取选中数据
      this.typeTemplateSelection = row;
    },
    getCurrentAgencyPlaceRow(row) {
      //获取选中数据
      this.templateSelection = row;
      this.filterTypeData.agencyCode = this.filterData.agencyCode;
      this.filterTypeData.placeCode = row.placeCode;
      _itemTable.load();
      this.itemRadio = "";
      this.enableBtn.xz = false;
      this.enableBtn.sc = false;
      this.enableBtn.tb = false;
      //  _itemTable.load();
    },
    checkSelect() {
      if (
        this.templateSelection.agencyCode == undefined &&
        this.templateSelection.placeCode == undefined
      ) {
        this.$alert("请先选择一条开票点记录");
        return true;
      }
      return false;
    },
    checkTypeSelect() {
      if (
        this.typeTemplateSelection.einvoiceTypeCode == undefined &&
        this.typeTemplateSelection.placeCode == undefined
      ) {
        this.$alert("请先选择一条开票点票种记录");
        return true;
      }
      return false;
    },
    onAdd() {
      if (this.checkSelect()) {
        return;
      }
      this.layout.edit = true;
      var typeList = ",";
      if (this.recordTypeData && this.recordTypeData.length > 0) {
        for (var i = 0; i < this.recordTypeData.length; i++) {
          typeList = typeList + this.recordTypeData[i].einvoiceTypeCode + ",";
        }
      }
      this.entityData = {
        agencyCode: this.templateSelection.agencyCode,
        agencyName: this.templateSelection.agencyName,
        placeCode: this.templateSelection.placeCode,
        placeName: this.templateSelection.placeName,
        creat: true,
        typeList: typeList
      };
    },
    onUpdate() {
      if (this.checkSelect()) {
        return;
      }
      if (this.checkTypeSelect()) {
        return;
      }
      this.layout.edit = true;
      this.entityData = {
        agencyCode: this.typeTemplateSelection.agencyCode,
        placeCode: this.typeTemplateSelection.placeCode,
        einvoiceTypeCode: this.typeTemplateSelection.einvoiceTypeCode,
        einvoiceCode: this.typeTemplateSelection.einvoiceCode,
        creat: false
      };
    },
    onDel() {
      if (this.checkSelect()) {
        return;
      }
      if (this.checkTypeSelect()) {
        return;
      }
      _kits.confirm({
        text: "确定删除此开票点收费项目以及明细?",
        yes: () => {
          _kits.api.call(
            "DELETEAGENCYPLACEITEM",
            {
              agencyCode: this.typeTemplateSelection.agencyCode,
              placeCode: this.typeTemplateSelection.placeCode,
              itemCode: this.typeTemplateSelection.itemCode
            },
            result => {
              if (result.returnCode == "0000") {
                this.$message(result.returnMsg);
                _itemTable.load();
                this.itemRadio = "";
              } else {
                this.$message.error(result.returnMsg);
              }
            }
          );
        }
      });
    },
    onDown() {
      if (this.checkSelect()) {
        return;
      }
      this.layout.loading = true;
      _kits.message("正在同步");
      _kits.api.call(
        "DOWNAGENCYPLACEITEM",
        {
          agencyCode: this.templateSelection.agencyCode,
          placeCode: this.templateSelection.placeCode
        },
        result => {
          if (result.returnCode == "0000") {
            this.$message.success(result.returnMsg);
            _itemTable.load();
            this.itemRadio = "";
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );
    },
    onDealItemAux(row) {
      this.itemAuxEntityData.agencyCode = row.agencyCode;
      this.itemAuxEntityData.placeCode = row.placeCode;
      this.itemAuxEntityData.itemCode = row.itemCode;
      this.layout.dealItemAux = true;
    },
    onRowDblclick(row, column, event) {
      console.log(row);
    },
    onFilter() {
      this.layout.loading = true;
      this.radio = "";
      _table.load();
      this.clearItemType();
      this.enableBtn.xz = true;
      this.enableBtn.xg = true;
      this.enableBtn.sc = true;
      this.enableBtn.tb = true;
    },
    dealAgency(datas) {
      //遍历树  获取id数组
      for (var i in datas) {
        if (datas[i].type == "2") {
          this.agencyNum++;
          this.agencyXx.push(datas[i]);
        }
        if (datas[i].children && datas[i].children.length > 0) {
          this.dealAgency(datas[i].children);
        }
      }
    },
    init() {
      this.treeLoading = true;
      _kits.api.call("AGENCYTREE", {}, result => {
        this.radio = "";
        this.itemRadio = "";
        this.treeLoading = false;
        if (result.data && result.data.length > 0) {
          this.dealAgency(result.data);
          if (this.agencyNum <= 1) {
            this.treeVisible = false;
            this.filterData.agencyCode = this.agencyXx[0].id;
            _table.load();
            this.filterTypeData = {};
            this.recordTypeData = [];
            this.radio = "";
            this.typeRadio = "";
            this.enableBtn.xz = true;
            this.enableBtn.xg = true;
            this.enableBtn.sc = true;
            this.enableBtn.tb = true;
            return;
          } else {
            this.treeVisible = true;
            this.agency = result.data;
            this.defaultOpen = [
              this.agency[0].id,
              this.agency[0].children[0].id
            ];
            _table.load();
          }
        }
      });
    },
    back(data) {
      this.layout.edit = false;
      _itemTable.load();
      this.itemRadio = "";
    },
    dealItemAuxBack() {
      this.layout.dealItemAux = false;
      _itemTable.load();
      this.itemRadio = "";
    },
    handleTreeClick(data, node, el) {
      if (data.type == "2") {
        this.filterTypeData = {};
        this.recordTypeData = [];
        this.radio = "";
        this.itemRadio = "";
        this.filterData.agencyCode = data.id;
        _table.load();
        this.enableBtn.xz = true;
        this.enableBtn.xg = true;
        this.enableBtn.sc = true;
        this.enableBtn.tb = true;
      }
    },
    clearItemType() {
      this.recordTypeData = [];
      this.typeTemplateSelection = {};
      this.typePagination = {
        total: 0,
        page: 1,
        pageSize: 10
      };
      this.itemRadio = "";
      this.filterTypeData = {};
    }
  },
  created() {
    this.pageWidth = window.innerWidth - 200;
    _kits = this.$kits();
    _table = _kits.table(
      "QUERYAGENCYPLACELIST",
      () => {
        this.isShowLoading = true;
        return Object.assign({}, this.filterData, this.pagination);
      },
      result => {
        this.isShowLoading = false;
        this.recordData = result.list;
        this.pagination.total = Number.parseInt(result.total);
      }
    );
    _itemTable = _kits.table(
      "QUERYPLACEITEMLIST",
      () => {
        this.isShowLoading = true;
        return Object.assign({}, this.filterTypeData, this.typePagination);
      },
      result => {
        this.isShowLoading = false;
        this.recordTypeData = result.list;
        this.typePagination.total = Number.parseInt(result.total);
      }
    );
    this.init();
  },
  mounted() {
    this.isShowLoading = false;
  },
  watch: {
    filterText(val) {
      this.$refs.agencyTree.filter(val);
    }
  }
};
</script>
<style scoped>
</style>